// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__1epxO","content":"MainHeader_content__5BuJT","link":"MainHeader_link__iFv7H"};